// extracted by mini-css-extract-plugin
export default {"dialog":"jx1vXJNBLyMGD8mA","subHeader":"Ogz8jfTxyLIZ3PE7","setDefault":"ng_01Ogr9aYi2mcP","categorySelect":"F6WIalkDnNsJ_wuV","vModalDefaultFooter":"H1Eoro8W40ktCFxX"};